import axios from 'axios'
//constantes
const dataInicial = {
    array: [],
    array2: [{}],
    datoperiodo: [{}],
    datopercepciones: [{}],
    datodeducciones: [{}],
    datoincidencias: [{}],
    datomovimientos: [{}]
}

//types
const OBTENER_REPORTES_EMP_DEPTA_EXITO = 'OBTENER_REPORTES_EMP_DEPTA_EXITO'
const OBTENER_REPORTES_EMP_DEPTA_BUSCADOR_EXITO = 'OBTENER_REPORTES_EMP_DEPTA_BUSCADOR_EXITO'
const OBTENER_PDI_PERIODO_VIGENTE_XEMP = 'OBTENER_PDI_PERIODO_VIGENTE_XEMP'
const OBTENER_HISTORIAL_PERCEPCIONES_EMP = 'OBTENER_HISTORIAL_PERCEPCIONES_EMP'
const OBTENER_HISTORIAL_DEDUCCIONES_EMP = 'OBTENER_HISTORIAL_DEDUCCIONES_EMP'
const OBTENER_HISTORIAL_INCIDENCIAS_EMP = 'OBTENER_HISTORIAL_INCIDENCIAS_EMP'
const OBTENER_HISTORIAL_MOVIMIENTOS_EMP = 'OBTENER_HISTORIAL_MOVIMIENTOS_EMP'

const { REACT_APP_API_URL } = process.env;
//reducer
export default function ReportesReducer(state = dataInicial, action) {

    switch (action.type) {
        case OBTENER_REPORTES_EMP_DEPTA_EXITO:
            return { ...state, array: action.payload, array2: action.payload }
        case OBTENER_REPORTES_EMP_DEPTA_BUSCADOR_EXITO:
            return { ...state, array2: action.payload }
        case OBTENER_PDI_PERIODO_VIGENTE_XEMP:
            return { ...state, datoperiodo: action.payload }
        case OBTENER_HISTORIAL_PERCEPCIONES_EMP:
            return { ...state, datopercepciones: action.payload }
        case OBTENER_HISTORIAL_DEDUCCIONES_EMP:
            return { ...state, datodeducciones: action.payload }
        case OBTENER_HISTORIAL_INCIDENCIAS_EMP:
            return { ...state, datoincidencias: action.payload }
        case OBTENER_HISTORIAL_MOVIMIENTOS_EMP:
            return { ...state, datomovimientos: action.payload }
        default:
            return state
    }
}
//acciones
export const obtenerhistorialempleadosdepta = (bd, dep) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/pdim/empleados/depto?guidempresa=${bd}&iddepartamento=${dep}`, requestOptions)
        dispatch({
            type: OBTENER_REPORTES_EMP_DEPTA_EXITO,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerhistortorial = (bd) => async (dispatch, getState) => {
    try {

        dispatch({
            type: OBTENER_REPORTES_EMP_DEPTA_BUSCADOR_EXITO,
            payload: bd
        })
    } catch (error) {
        console.log('No se procedio a actualizar la lista', error)
    }
}

export const obtenerpdiperiodovigentexemp = (bd, idemp) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/pdim/empleado/pv?guidempresa=${bd}&idempleado=${idemp}`, requestOptions)
        dispatch({
            type: OBTENER_PDI_PERIODO_VIGENTE_XEMP,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerhistorialpercepcionesemp = (bd, idemp) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/historial/percepciones/empleado?guidempresa=${bd}&idempleado=${idemp}`, requestOptions)
        dispatch({
            type: OBTENER_HISTORIAL_PERCEPCIONES_EMP,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerhistorialdeduccionesemp = (bd, idemp) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
         headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/historial/deducciones/empleado?guidempresa=${bd}&idempleado=${idemp}`, requestOptions)
        dispatch({
            type: OBTENER_HISTORIAL_DEDUCCIONES_EMP,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerhistorialincidenciasemp = (bd, idemp) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
         headers: {
            'Authorization': `Bearer ${token}`
         }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/historial/incidencias/empleado?guidempresa=${bd}&idempleado=${idemp}`, requestOptions)
        dispatch({
            type: OBTENER_HISTORIAL_INCIDENCIAS_EMP,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}

export const obtenerhistorialmovimientosemp = (bd, idemp) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
         headers: {
            'Authorization': `Bearer ${token}`
         }
    }
    try {
        const res = await axios.get(`${REACT_APP_API_URL}/reportes/historial/movimientos/empleado?guidempresa=${bd}&idempleado=${idemp}`, requestOptions)
        dispatch({
            type: OBTENER_HISTORIAL_MOVIMIENTOS_EMP,
            payload: res.data
        })
    } catch (error) {
        console.log(error)
    }
}